// extracted by mini-css-extract-plugin
export var content = "_nh-1";
export var fullScreen = "_nh-0";